import React from "react";
import {useTranslation} from "react-i18next";

export default function Btn(props) {

    let label = props.label;
    let curClass = props.curClass;
    let clickFunction = props.clickFunction;
    let btnValue = props.btnValue;
    let doNotTranslate = props.doNotTranslate;

    const {t, i18n} = useTranslation();

    let functionCall = btnValue !== null ? () => clickFunction(!btnValue) : clickFunction;

    // Get the translation, if defined
    label = !doNotTranslate && i18n.exists(label) ? t(label) : label;

    return <span className={"nowrap"}>
        <span className={curClass} style={{marginRight: '4px'}} onClick={functionCall}>
            {label}
        </span>
    </span>;
}
